// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SuccsesFreeSpins_main__dvfR\\+{

    height: 400px;
    background-size: contain; /* Измените на contain для полного отображения изображения */
    background-position: top center; /* Позиция верхнего центра */
    background-repeat: no-repeat; /* Избегает повторения изображения */
    border-radius: 10px;



}
.SuccsesFreeSpins_continaer__nBbpm{
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap:30px;
    height: 400px;
    font-size: 25px;

    padding: 10px;
    background: linear-gradient(315deg, rgb(40, 3, 47) 0%, rgba(184, 132, 243, 0.55) 100%);
    font-family: Poppins, sans-serif;
    color: white;
    letter-spacing: 0.6px;

    border-radius: 10px;
}
button{
    display: flex;
    align-items: center;
    background-color: #4caf50;
    border-radius: .5rem;
    color: #fff;
    display: flex;
    font-family: Poppins, sans-serif;
    font-weight: 400;
    gap: 6px;
    letter-spacing: 1px;
    padding: .4rem 1rem;
}
@media (max-width: 1000px) {
    .SuccsesFreeSpins_continaer__nBbpm {
        height: 214px;



    }
}`, "",{"version":3,"sources":["webpack://./src/components/Modals/components/SuccsesFreeSpins/SuccsesFreeSpins.module.css"],"names":[],"mappings":"AAAA;;IAEI,aAAa;IACb,wBAAwB,EAAE,4DAA4D;IACtF,+BAA+B,EAAE,4BAA4B;IAC7D,4BAA4B,EAAE,oCAAoC;IAClE,mBAAmB;;;;AAIvB;AACA;IACI,aAAa;IACb,WAAW;IACX,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,QAAQ;IACR,aAAa;IACb,eAAe;;IAEf,aAAa;IACb,sFAAsF;IACtF,gCAAgC;IAChC,YAAY;IACZ,qBAAqB;;IAErB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,oBAAoB;IACpB,WAAW;IACX,aAAa;IACb,gCAAgC;IAChC,gBAAgB;IAChB,QAAQ;IACR,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI;QACI,aAAa;;;;IAIjB;AACJ","sourcesContent":[".main{\n\n    height: 400px;\n    background-size: contain; /* Измените на contain для полного отображения изображения */\n    background-position: top center; /* Позиция верхнего центра */\n    background-repeat: no-repeat; /* Избегает повторения изображения */\n    border-radius: 10px;\n\n\n\n}\n.continaer{\n    display: flex;\n    width: 100%;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    gap:30px;\n    height: 400px;\n    font-size: 25px;\n\n    padding: 10px;\n    background: linear-gradient(315deg, rgb(40, 3, 47) 0%, rgba(184, 132, 243, 0.55) 100%);\n    font-family: Poppins, sans-serif;\n    color: white;\n    letter-spacing: 0.6px;\n\n    border-radius: 10px;\n}\nbutton{\n    display: flex;\n    align-items: center;\n    background-color: #4caf50;\n    border-radius: .5rem;\n    color: #fff;\n    display: flex;\n    font-family: Poppins, sans-serif;\n    font-weight: 400;\n    gap: 6px;\n    letter-spacing: 1px;\n    padding: .4rem 1rem;\n}\n@media (max-width: 1000px) {\n    .continaer {\n        height: 214px;\n\n\n\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `SuccsesFreeSpins_main__dvfR+`,
	"continaer": `SuccsesFreeSpins_continaer__nBbpm`
};
export default ___CSS_LOADER_EXPORT___;
